export default __webpack_public_path__ + "static/steps-to-maximize-efforts-e997ba4d2ce2273e9238bcd0ab6aef6a.webp";